import { Checkbox } from 'antd';
import styled from 'styled-components';
import { CredusText, color } from 'ui';

import { TestQuestions } from '../../../../../contexts/TestContext';

interface TdProps {
  background?: string;
  gap?: string;
}

interface PublishTestTableProps {
  questions: TestQuestions[];
}

const PublishTestTable = ({ questions }: PublishTestTableProps) => {
  return (
    <>
      <Table>
        <tr>
          <Th>
            <Div>
              <Checkbox />
            </Div>
          </Th>
          <Th>
            <Div>
              {' '}
              <CredusText size="md">#</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              <CredusText size="md">Question</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              {' '}
              <CredusText size="md">Type</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              <CredusText size="md">Points</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              <CredusText size="md">Option 1</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              <CredusText size="md">Option 2</CredusText>
            </Div>
          </Th>
          <Th>
            <Div>
              {' '}
              <CredusText size="md">Option 3</CredusText>
            </Div>
          </Th>
        </tr>
        {questions?.map((data: TestQuestions, index: number) => {
          const {
            text,
            type,
            point,
            option1Status,
            option2Status,
            option3Status,
          } = data;
          const optionBgColor = (status: null | string) =>
            data?.type == 'SA' ? '' : status ? '#0A8B38' : '#FDC453';
          const optionTextColor = (status: null | string) =>
            data?.type == 'SA'
              ? color.black
              : status
              ? color.white
              : color.black;
          return (
            <tr>
              <Td>
                <Div>
                  <Checkbox />
                </Div>
              </Td>
              <Td>
                <Div>
                  <CredusText size="sm">Q{index + 1}</CredusText>
                </Div>
              </Td>
              <Td>
                <Div>
                  <CredusText size="sm">{text}</CredusText>
                </Div>
              </Td>
              <Td>
                <Div>
                  <CredusText size="sm">{type}</CredusText>
                </Div>
              </Td>
              <Td>
                <Div>
                  <CredusText size="sm">{point}</CredusText>
                </Div>
              </Td>
              <Td background={optionBgColor(option1Status)}>
                <Div>
                  <CredusText size="sm" color={optionTextColor(option1Status)}>
                    {data?.option1 ?? '-'}
                  </CredusText>
                </Div>
              </Td>
              <Td background={optionBgColor(option2Status)}>
                <Div>
                  <CredusText size="sm" color={optionTextColor(option2Status)}>
                    {data?.option2 ?? '-'}
                  </CredusText>
                </Div>
              </Td>
              <Td background={optionBgColor(option3Status)}>
                <Div>
                  <CredusText size="sm" color={optionTextColor(option3Status)}>
                    {data?.option3 ?? '-'}
                  </CredusText>
                </Div>
              </Td>
            </tr>
          );
        })}
      </Table>
    </>
  );
};

export default PublishTestTable;

const Table = styled.table`
  width: 100%;
`;

const Th = styled.th`
  background: #ffeae7;
  padding: 1rem;
  min-width: 44px;
`;
const Td = styled.td<TdProps>`
  background: ${({ background }) => (background ? background : ' #fbfbfb')};
  gap: ${(props) => props.gap};
  height: 58px;
  padding: 1rem 1.2rem;
  min-width: 44px;
`;

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;
